<template>
    <div v-if="additionals && additionals.salaVacinacao.id">
        <rkm-form
            ref="Form"
            v-if="model"
        >
            <rkm-area
                type="fieldset"
                title="Cadastro"
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-input
                            label="Profissional"
                            v-model="model.usuario"
                            disabled
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-input
                            label="Unidade"
                            v-model="model.unidade"
                            disabled
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-input
                            label="Ocupação"
                            v-model="model.ocupacao"
                            disabled
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-input
                            label="Equipe"
                            v-model="model.equipe"
                            disabled
                            />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-date-picker
                            label="Data a aplicação"
                            v-model="model.data"
                            :validations="validations.data"
                            disabled
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-button
                            color="primary"
                            :label="false"
                            @click="add"
                            :disabled="model.exportado"
                        >
                            Adicionar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-form>

        <rkm-area
            type="fieldset"
            title="Vacinações individualizadas"
            v-if="items.length"
        >
            <rkm-table
                :items="items"
                :fields="fields"
                hide-pagination
                hide-filters
                no-footer-sorting
            >
                <template v-slot:cell(nascimento)="row">
                        {{ row.value | formatDate }}
                    </template>

                <template v-slot:cell(actions)="{ item, index }">
                    <rkm-button
                        @click="handleEdit(index)"
                        color="primary"
                        title="Editar"
                        small
                    >
                        <rkm-icon icon="search" />
                    </rkm-button>

                    <rkm-button
                        @click="handleDelete(item.id)"
                        color="danger"
                        title="Excluir"
                        small
                        :disabled="model.exportado"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>

        <Modal
            ref="Modal"
            :model="model"
            :form="form"
            :items="items"
            :additionals="additionals"
        />
    </div>

    <rkm-alert v-else color="warning">
        A unidade logada não é uma sala de vacinação, favor cadastrá-la para efetuar um registro de vacinação.
    </rkm-alert>
</template>

<script>
import permissao from '@/enums/atencao-basica/parametrizacao/permissao'
import Modal from '@/components/atencao-basica/ficha-vacinacao/Modal'
import { repository, error } from '@/mixins';
import formats from '@/filters/formats'
import { mapActions } from "vuex";

export default {
    filters: {
        formatDate: formats.formatDate,
    },
    components: {
        Modal
    },
    created() {
        this.repositories = {
            fichaVacinacao: this.getConectaSusRepository('atencaoBasica.fichaVacinacao'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
        }
        this.load()
    },
    computed: {
        validations() {
            return {
                unidade: {
                    required: true
                },
                usuario: {
                    required: true
                },
                ocupacao: {
                    required: true
                },
                equipe: {
                    required: true
                },
                data: {
                    required: true
                }
            }
        },
        autocompleteRequestParams() {
            return {
                usuario: {
                    with_not_regularized: true,
                    with_atencao_basica_equipe: true,
                    with_atencao_basica_permissao: this.enums.permissao.FICHA_DE_VACINACAO,
                }
            }
        },
        searchFields() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ]
                }
            }
        },
        fields() {
            return [
                {
                    key: "prontuario",
                    label: "Prontuário",
                    fixed: true
                },
                {
                    key: "paciente",
                    label: "Paciente",
                    fixed: true
                },
                {
                    key: "cns",
                    label: "CNS",
                    fixed: true
                },
                {
                    key: "nascimento",
                    label: "Data de nascimento",
                    fixed: true
                },
                {
                    key: "sexo",
                    label: "Sexo",
                    fixed: true
                },
                {
                    key: "turnoNome",
                    label: "Turno",
                    fixed: true
                },
                {
                    name: 'actions',
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        }
    },
    data() {
        return {
            items: [],
            model: null,
            form: null,
            additionals: null,
            enums: {
                permissao
            },
            unidades: [],
            equipes: []
        }
    },
    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),
        load() {
            this.setLoading()
            this.repositories.fichaVacinacao.edit(this.id)
                .then(({ data }) => {
                    this.model = data.model
                    this.form = data.form
                    this.items = data.items
                    this.additionals = data.additionals
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        add() {
            this.$refs.Form.validate()
                .then(valid => {
                    if(!valid) return

                    this.$refs.Modal.open()
                })
        },
        handleEdit(index) {
            this.$refs.Modal.open(this.items[index])
        },
        handleDelete(id) {
            const destroy = async () => {
                this.setLoading()
                this.repositories.fichaVacinacao.destroyAll(id)
                    .then(() => {
                        this.load()
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
            this.showDeleteConfirmation(
                'Deseja realmente excluir a vacinação?',
                destroy,
                this.handleError
            )
        }
    },
    mixins: [ repository, error, formats ],
    props: {
            id: { type: Number, default: null },
        }
    }
</script>